export default __webpack_public_path__ + "static/logo-f77d1753b017974c3694940ae3233aa9.svg";